import { AfterViewInit, Component, ComponentFactory, ComponentFactoryResolver, ComponentRef, EventEmitter, Input, Output, ViewChild, ViewContainerRef } from "@angular/core";
import { AppService } from "@api";
import { RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { PeriodoEvaluacion } from "@modelo/proceso/periodoevaluacion.model";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";
import { AsignacionEvaluacionPadresMateriaComponent } from "./asignacionevaluacionpadresseccion/asignacionevaluacionpadres_materia.component";
import { AsignacionEvaluacionPadresFormComponent } from "./asignacionevaluacionpadresform.component";
import { MatTabGroup } from "@angular/material/tabs";
import { LocationStrategy } from "@angular/common";
import { EvaluacionAlumno } from "@modelo/global/EvaluacionAlumno.model";
import { EvaluacionPendientePrevisualizarAlumnoComponent } from "@contenido/AppContent/evaluacionpendiente/alumno/previsualizar/previsualizar_alumno.component";



@Component({
    selector: 'asignacionevaluacionpadres',
    templateUrl: './asignacionevaluacionpadres.component.html',
})

export class AsignacionEvaluacionPadresComponent implements AfterViewInit {
    public errorActivo!: boolean;
    entidad: PeriodoEvaluacion;
    @ViewChild('tab') private tab!: MatTabGroup;
    @ViewChild('general') private asignacionevaluacionpadreComponent!: AsignacionEvaluacionPadresMateriaComponent;
    @Input() accion!: {accion: string, entidad:any};
    @Input() id!: number;
    @Input() identificador!: number;
    @Output() output = new EventEmitter();

    asignacion:any[] = [];
    consulta:boolean = false;
    visualizar: boolean = false;

    @ViewChild("asignacionevaluacionpadresform", {read: ViewContainerRef}) asignacionevaluacionpadresform!: ViewContainerRef;

    @ViewChild("containerEvaluacion", {read: ViewContainerRef}) containerEvaluacion!: ViewContainerRef;

    constructor(private appService: AppService,private location: LocationStrategy, public sistemaService: SistemaService, public translate: TranslateService, private mensajeService: MensajeService, public _cfr: ComponentFactoryResolver){
        this.entidad = new PeriodoEvaluacion();
        history.pushState(null, "", window.location.href);
        this.location.onPopState(() => {
            this.Salir();
        });
    }

    ngAfterViewInit() {
        if (this.identificador == 2) {
            this.visualizar = true;
        }
        this.SetPeriodoEvaluacion();
        this.SetAsignacion();
                // 1. Save the click handler for later
                const handleTabClick = this.tab._handleClick;
                // 2. Replace the click handler with our custom function
                this.tab._handleClick = (tab, header, index) => {
                    switch (this.tab.selectedIndex) {
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            handleTabClick.apply(this.tab, [tab, header, index]);
                            break;
                    }

                };
    }

    SetPeriodoEvaluacion(){
        this.appService.Post("planeacion/periodoevaluacion/buscar", {"periodoevaluacionid":this.id}).then(res=>{
            if(res.status == RespuestaEstatusEnum.Success){
                this.entidad = new PeriodoEvaluacion(res.data[0]);
            }
        })
    }

    SetAsignacion(){
        this.appService.Get("planeacion/asignacionevaluacion/asignacion").then(res=>{
            if(res.status == RespuestaEstatusEnum.Success){
                this.asignacion = res.data;
            }
        })
    }

    formulario(){
        if(this.asignacionevaluacionpadreComponent.valoraccion){
            this.cargarContenedorFormulario({accion:this.asignacionevaluacionpadreComponent.valoraccion.accion,entidad:this.asignacionevaluacionpadreComponent.valoraccion.entidad, periodoevaluacionportipoevaluacionid:this.asignacionevaluacionpadreComponent.valoraccion.periodoevaluacionportipoevaluacionid, accionid:this.asignacionevaluacionpadreComponent.valoraccion.accionid});
        }
    }

    cargarContenedorFormulario(data: {accion: string, entidad: any, periodoevaluacionportipoevaluacionid:number, accionid:number}) {
        this.consulta = true;
        this.asignacionevaluacionpadresform.clear();
        const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(AsignacionEvaluacionPadresFormComponent);
        var ref: ComponentRef<any> = this.asignacionevaluacionpadresform.createComponent(factory);
        ref.instance.accion = {accion: data.accion, entidad: data.entidad};
        ref.instance.id = this.id;
        ref.instance.entidad = new PeriodoEvaluacion(this.entidad);
        ref.instance.identificador = data.accionid;
        ref.instance.tipoevaluacionid = this.accion.entidad.tipoevaluacionid;
        ref.instance.cicloid = this.entidad.cicloid;
        ref.instance.gradoid = data.entidad.gradoid;
        ref.instance.periodoevaluacionportipoevaluacionid = data.periodoevaluacionportipoevaluacionid;
        ref.instance.nivelid = this.accion.entidad.nivelid;
        ref.instance.tipoevaluacionid = this.accion.entidad.tipoevaluacionid;
        ref.instance.output.subscribe((cambio: boolean) => {
            this.consulta = false;
            ref.destroy();
            if(cambio){
                this.asignacionevaluacionpadreComponent.SetNivelYGrado();
            }
        });
    }

    cargarprevisualizacion(e:any){
        let entidadtemporal = new EvaluacionAlumno(e);
        entidadtemporal.periodoevaluacionid = this.entidad.periodoevaluacionid;
        entidadtemporal.puesto = "Rector";
        entidadtemporal.departamento = "Rectoria";
        entidadtemporal.nombre = "Previsualizar";
        entidadtemporal.periodoevaluacion = this.entidad.descripcion;
        this.consulta = true;
        this.containerEvaluacion.clear();
        const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(EvaluacionPendientePrevisualizarAlumnoComponent);
        var ref: ComponentRef<any> = this.containerEvaluacion.createComponent(factory);
        ref.instance.entidad = entidadtemporal;
        ref.instance.output.subscribe((cambio: boolean) => {
            this.consulta = false;
            ref.destroy();
            if (cambio) {

            }
        });
    }

    Guardar(){
        this.asignacionevaluacionpadreComponent.Guardar();
        }

    Salir(){
        this.output.next();
    }
}
